function convertArrayOfObjectsToCSV(data: Record<string, unknown>[]): string {
    const csv: string[] = [];
    const headers = Object.keys(data[0]);

    csv.push(headers.join(','));
    for (const row of data) {
        const values = headers.map((header) => {
            const escaped = ('' + row[header]).replace(/"/g, '\\"');
            return `"${escaped}"`;
        });
        csv.push(values.join(','));
    }

    return csv.join('\n');
}

export function downloadCSV(
    data: Record<string, unknown>[],
    filename: string
): void {
    if (!data.length) return;

    const csv = convertArrayOfObjectsToCSV(data);
    const blob = new Blob(['﻿' + csv], {
        type: 'text/csv;charset=utf-8;',
    });

    const link = document.createElement('a');
    if (link.download !== undefined) {
        const url = URL.createObjectURL(blob);
        link.setAttribute('href', url);
        link.setAttribute('download', filename + '.csv');
        link.style.visibility = 'hidden';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(url);
    }
}
